<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading && !!importElement">

  <mat-card appearance="outlined">
    <mat-card-title>Details</mat-card-title>
    <table>
      <tr>
        <td>title:</td>
        <td>{{importElement.title}}</td>
      </tr>
      <tr>
        <td>typeTitle:</td>
        <td>{{importElement.typeTitle}}</td>
      </tr>
      <tr>
        <td>id:</td>
        <td>{{importElement._id}}</td>
      </tr>
      <tr>
        <td>typeId:</td>
        <td>{{importElement.typeId}}</td>
      </tr>
    </table>
  </mat-card>

  <div class="spacer"></div>

  <json-content-table *ngIf="!isLoading && jsonImportProperties" [displayStyle]="'detail'" [json]="jsonImportProperties"
                          [title]="'importProperties'">
  </json-content-table>

  <div *ngIf="jsonImportProperties" class="spacer"></div>

  <json-content-table *ngIf="!isLoading && jsonDetail" [displayStyle]="'detail'" [json]="jsonDetail" [title]="'Settings'">
  </json-content-table>

  <div *ngIf="jsonDetail" class="spacer"></div>

  <mat-card appearance="outlined">
    <mat-card-title>Statistic</mat-card-title>
    <table>
      <tr>
        <td>entryCount:</td>
        <td>{{importElement.entryCount}}</td>
        <td>fileCount:</td>
        <td>{{importElement.fileCount}}</td>
      </tr>
      <tr>
        <td>menuItemCount:</td>
        <td>{{importElement.menuItemCount}}</td>
        <td>filterCount:</td>
        <td>{{importElement.filterCount}}</td>
      </tr>
      <hr>
      <tr>
        <td>created:</td>
        <td>{{importElement.created | date:'dd MMMM yyyy'}}</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>updated:</td>
        <td>{{importElement.updated | date:'dd MMMM yyyy HH:mm'}}</td>
        <td>successfull:</td>
        <td>{{importElement.wasLastSuccessful}}</td>
      </tr>
      <tr>
        <td>lastFailed:</td>
        <td>{{importElement.lastFailed | date:'dd MMMM yyyy HH:mm'}}</td>
        <td>failCount:</td>
        <td>{{importElement.failCount}}</td>
      </tr>
      <tr>
        <td>lastSuccessed:</td>
        <td>{{importElement.lastSuccessed | date:'dd MMMM yyyy HH:mm'}}</td>
        <td>successCount:</td>
        <td>{{importElement.successCount}}</td>
      </tr>
      <hr>
      <tr>
        <td>lastCheck:</td>
        <td>{{importElement.lastCheck | date:'dd MMMM yyyy HH:mm'}}</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>nextCheck:</td>
        <td>{{importElement.nextCheck | date:'dd MMMM yyyy HH:mm'}}</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>lastDuration:</td>
        <td>{{importElement.lastJobDuration}}</td>
        <td></td>
        <td></td>
      </tr>
    </table>
    <json-content-table *ngIf="!isLoading && importElement.jobStatus" [displayStyle]="'detail'" [json]="importElement.jobStatus"
                            [title]="'Job-Status'">
    </json-content-table>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined" *ngIf="importElement.assignableMenuItems && importElement.assignableMenuItems.length">
    <mat-card-title>Assignable Menu Items</mat-card-title>
    <table>
      <ng-container *ngFor="let menuItem of importElement.assignableMenuItems">
        <tr>
          <td>title:</td>
          <td>{{menuItem.title}}</td>
          <td>id:</td>
          <td>{{menuItem.menuItemId}}</td>
        </tr>
      </ng-container>
    </table>
  </mat-card>

  <div *ngIf="importElement.assignableMenuItems && importElement.assignableMenuItems.length" class="spacer"></div>

  <ng-container *ifPrivilege="{ name: 'read', value: 'compositions' }">
    <mat-card appearance="outlined" *ngIf="!isLoading && compositions && compositions.length">
      <mat-card-title>Connected To Composition</mat-card-title>
      <table>
        <ng-container *ngFor="let item of compositions">
          <tr>
            <td>title:</td>
            <td *ngIf="item.title">{{item.title}}</td>
            <td>type:</td>
            <td *ngIf="item.type && item.type.title">{{item.type.title}}</td>
            <td>Go to:</td>
            <td *ngIf="item._id"><i (click)="navigateToComposition(item._id)" class="material-icons">link</i></td>
          </tr>
        </ng-container>
      </table>
    </mat-card>
  </ng-container>

</page-content>

